"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInactivity = void 0;
const react_idle_timer_1 = require("react-idle-timer");
const react_1 = require("react");
const user_context_1 = require("../user/user-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function useInactivity(timeout) {
    const { logout, isLogedIn } = react_1.useContext(user_context_1.UserContext);
    const handleOnIdle = event_callback_hook_1.useEventCallback(() => {
        if (isLogedIn()) {
            logout(true);
        }
    });
    react_idle_timer_1.useIdleTimer({
        timeout: timeout * 1000,
        onIdle: handleOnIdle,
        debounce: 500,
    });
}
exports.useInactivity = useInactivity;
//# sourceMappingURL=inactivity-hook.js.map